import Button from 'components/button';
import {
  ButtonIconWrapper,
  IconButton,
  InputWrapper,
} from 'components/questions/question.styles';
import TextInput from 'components/text-input';
import { Label } from 'components/text-input/text-input.styles';
import React, { FC } from 'react';
import { useFieldArray } from 'react-hook-form';
import { settings } from 'utils/config';
import { ReactComponent as PlusIcon } from '../../assets/icons/icon-plus.svg';
import { ReactComponent as TrashIcon } from '../../assets/icons/icon-trash.svg';

interface Props {
  nestIndex: number;
  control: any;
  register: any;
}

const RoutesList: FC<Props> = ({ nestIndex, control, register }) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: `places[${nestIndex}].routes`,
  });

  return (
    <>
      <Label>How will you get there?</Label>

      {fields.map((route, index) => (
        <InputWrapper key={route.id}>
          <TextInput
            type='text'
            placeholder='Example: Sesame Street to Safety Drive, to the highway.'
            id={`route_${route.id}`}
            defaultValue={route.detail}
            name={`places[${nestIndex}].routes[${index}].detail`}
            ref={register()}
          />
          {index !== 0 && (
            <IconButton
              type='button'
              isInline
              aria-label='delete contact'
              onClick={() => {
                remove(index);
              }}
            >
              <TrashIcon aria-hidden />
            </IconButton>
          )}
        </InputWrapper>
      ))}
      <Button
        variant='transparent'
        onClick={() => append({ detail: '' })}
        disabled={fields.length >= settings.maxNumOfItems}
      >
        <ButtonIconWrapper>
          <PlusIcon />
        </ButtonIconWrapper>
        Add another route
      </Button>
    </>
  );
};

export default RoutesList;
